import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** The standard top-of-page band for non-home pages. */
export function PageHero({
  eyebrow,
  title,
  lead,
  image,
  children,
  className,
}: {
  eyebrow?: string;
  title: ReactNode;
  lead?: ReactNode;
  image?: string;
  children?: ReactNode;
  className?: string;
}) {
  if (image) {
    return (
      <section className={cn("relative flex min-h-[52vh] items-end overflow-hidden", className)}>
        <img src={image} alt="" className="absolute inset-0 size-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/50 to-ink/25" />
        <div className="relative mx-auto w-full max-w-7xl px-5 pb-14 pt-32 sm:px-8">
          <div className="max-w-2xl">
            {eyebrow && (
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-bright">
                {eyebrow}
              </p>
            )}
            <h1 className="mt-2 text-4xl font-medium tracking-tight text-white sm:text-5xl">
              {title}
            </h1>
            {lead && <p className="mt-4 text-lg leading-relaxed text-white/80">{lead}</p>}
            {children}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={cn("bg-cream pb-14 pt-28 sm:pt-36", className)}>
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          {eyebrow && (
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand">{eyebrow}</p>
          )}
          <h1 className="mt-2 text-4xl font-medium tracking-tight text-ink sm:text-5xl">{title}</h1>
          {lead && <p className="mt-4 text-lg leading-relaxed text-ink/65">{lead}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}
